(function ($, undefined) {
	'use strict';
	var utils;
	var locationsUtils;

	var init = function () {
		utils = Fw.component.models().utils;
		locationsUtils = Fw.component.models().locationsUtils;

		$('.submit-location-document-form').on('click', onSaveDocument);
	};

	function onSaveDocument() {
		var form = $('.add-location-document-form');
		var fileInput = $('input[type=file]', form);
		var input = $('input[type="text"]', form);
		form.removeClass('has-error');
		fileInput.removeClass('error');
		input.removeClass('error');
		var title = input.val();

		if (fileInput[0].files.length === 0) {
			fileInput.addClass('error');
			form.addClass('has-error');
		}
		if (input.val().length === 0) {
			input.addClass('error');
			form.addClass('has-error');
		}

		locationsUtils.addOverlay();
		if (!form.hasClass('has-error')) {
			utils.uploadSecureFiles(fileInput[0].files, (response) => {
				const [id, filename] = response.media.mediaIds[0].split(" - ");
				saveNewDocument(id, filename, title);
				appendNewDocumentRow(id, filename, title);
			}, form.attr('data-location-id'), "document", utils.UPLOAD_KEY);
		}
		else {
			saveCurrentDocuments();
		}
	}

	function getCurrentDocuments() {
		var table = $('.table_location-documents');
		var rows = $('.table__tr:not(.template):not(.table__tr_head)', table);
		var documents = $.map(rows, (el) => {
			return {
				"title": $('.table__td', el).eq(0).attr('data-value'),
				"filename": $('.table__td', el).eq(2).attr('data-value'),
				"id": $(el).attr('data-value')
			}
		});
		return documents;
	}

	function saveCurrentDocuments() {
		var documents = getCurrentDocuments();
		saveDocuments(documents);
	}

	function saveNewDocument(id, filename, title) {
		var documents = getCurrentDocuments();
		documents.push({
			"title": title,
			"filename": filename,
			"id": id
		});
		saveDocuments(documents);
	}

	function saveDocuments(documentsJson) {
		var form = $('.location-form-content');
		const data = {
			id: form.find('[name="id"]').val(),
			field16: JSON.stringify(documentsJson)
		};
		locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
			if (id != null) {
				form.find('[name="id"]').val(id);
				locationsUtils.showMessage(form, '_success');
				form.find('.add-location-info__client_hidden')
					.removeClass('add-location-info__client_hidden')
					.find('input')
					.val(id);
			} else {
				locationsUtils.showMessage(form, '_server');
			}
			location.reload();
		});
	}

	function appendNewDocumentRow(id, filename, title) {
		var table = $('.table_location-documents');
		var newRow = $('.table__tr.template:not(.table__tr_head)', table).clone(true);
		$('.table__td', newRow).eq(0).text(title);
		$('.table__td', newRow).eq(0).attr('data-value', title);
		$('.table__td', newRow).eq(2).text(filename.substr(filename.indexOf('-') + 1));
		$('.table__td', newRow).eq(2).attr('data-value', filename);
		$('.table__btn_delete', newRow).attr('data-item-id', id);
		$('.table__btn_edit', newRow).attr('data-id', id);
		newRow.attr('data-id', 'location-documents-row-' + id);
		newRow.attr('data-value', id);
		newRow.removeClass('template');
		table.append(newRow);
	}

	$(window).ready(function () {
		init();
	});
})(jQuery);
